import { render, staticRenderFns } from "./ManageClerksModal.vue?vue&type=template&id=5cd8ea32&scoped=true"
import script from "./ManageClerksModal.vue?vue&type=script&lang=js"
export * from "./ManageClerksModal.vue?vue&type=script&lang=js"
import style0 from "./ManageClerksModal.vue?vue&type=style&index=0&id=5cd8ea32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8ea32",
  null
  
)

export default component.exports